var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29289 1.29289C9.48043 1.10536 9.73478 1 10 1H18C19.6569 1 21 2.34315 21 4V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V4C19 3.44772 18.5523 3 18 3H11V8C11 8.55228 10.5523 9 10 9H5V20C5 20.5523 5.44772 21 6 21H8C8.55228 21 9 21.4477 9 22C9 22.5523 8.55228 23 8 23H6C4.34315 23 3 21.6569 3 20V8C3 7.73478 3.10536 7.48043 3.29289 7.29289L9.29289 1.29289ZM6.41421 7H9V4.41421L6.41421 7ZM19 18C19 17.4477 19.4477 17 20 17H21C21.5523 17 22 17.4477 22 18V22C22 22.5523 21.5523 23 21 23C20.4477 23 20 22.5523 20 22V19C19.4477 19 19 18.5523 19 18ZM13 20C13 19.4477 13.4477 19 14 19C14.5523 19 15 19.4477 15 20C15 20.5523 14.5523 21 14 21C13.4477 21 13 20.5523 13 20ZM14 17C12.3431 17 11 18.3431 11 20C11 21.6569 12.3431 23 14 23C15.6569 23 17 21.6569 17 20C17 18.3431 15.6569 17 14 17ZM20 12C19.4477 12 19 12.4477 19 13C19 13.5523 19.4477 14 20 14C20.5523 14 21 13.5523 21 13C21 12.4477 20.5523 12 20 12ZM17 13C17 11.3431 18.3431 10 20 10C21.6569 10 23 11.3431 23 13C23 14.6569 21.6569 16 20 16C18.3431 16 17 14.6569 17 13ZM13 10C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V11C15 10.4477 14.5523 10 14 10H13Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase64);
export default __webpack_public_path__ + "static/media/base64.a48bc37097d6b7e8702da7acd64982f7.svg";
export { ForwardRef as ReactComponent };